export const sendToMap = {
  program: "PROGRAM",
  banner: "BANNER",
  mixer: "MIXER",
  gallery: "GALLERY",
};

export const sendToArray = Object.values(sendToMap);
